import React, { useState, useEffect } from 'react';
import GrClose from '@meronex/icons/gr/GrClose';

import { winnreAuth } from '../../../utils/axios';
import { getConfig } from '../../.././utils/config';
import SideModal from '../../Organisms/SideModal';

function SurveyFrom({ showModal, onClickCancel }) {
    const config = getConfig();
    const [comments, setComments] = useState('');
    const [checkedState, setCheckedState] = useState([]);
    const [formIsValid, setFormIsValid] = useState(false);
    const [isRandomQuestion, setisRandomQuestion] = useState(false);
    const [question, setQuestion] = useState([]);

    // validation check for input text area
    const commentsChangedHandler = (event) => {
        setComments(event.target.value);
        setFormIsValid(event.target.value.trim().length > 0);
    };

    // On click possible answers
    const handleBlockClick = (index) => {
        if (question.type === 'MCQ') {
            const updatedCheckedState = new Array(
                question.possibleAnswers.length
            ).fill(false);
            updatedCheckedState[index] = true;
            setCheckedState(updatedCheckedState);
            setFormIsValid(true);
        } else if (question.type === 'MULTI_MCQ') {
            const updatedCheckedState = checkedState.map((item, idx) =>
                idx === index ? !item : item
            );
            setCheckedState(updatedCheckedState);
            setFormIsValid(updatedCheckedState.includes(true));
        }
    };

    // Cancel click
    const OnCancelClick = () => {
        window?.webengage?.track('SubmitDismissed', {
            questionsId: question.id
        });
        onClickCancel();
    };
    // Form submit section
    const handleSubmit = () => {
        let answer = '';
        if (question.type === 'FREE') {
            if (!comments.trim()) {
                return;
            }
            answer = comments;
        } else if (question.type === 'MCQ' || question.type === 'MULTI_MCQ') {
            const selectedAnswers = question.possibleAnswers.filter(
                (answer, index) => checkedState[index]
            );
            if (selectedAnswers.length === 0) {
                return;
            }
            setCheckedState(
                new Array(question.possibleAnswers.length).fill(false)
            );
            answer = selectedAnswers.join(', ');
        }

        // Submit api
        winnreAuth({
            method: 'POST',
            url: `winnre/user/mini-survey-answer/submit`,
            data: {
                answer: answer,
                questionId: question.id,
                answerSource: 'WEB',
                userSyncClientId: config.id
            }
        })
            .then(() => {
               
                window?.webengage?.track('SurveyAnswered', {
                    questionsId: question.id,
                    questionText: question.question,
                    answerText: answer
                });
                OnCancelClick();
            })
            .catch(() => {});
    };

    useEffect(() => {
        // Fetch random question
        winnreAuth({
            method: 'get',
            url: `/winnre/user/mini-survey-question/get-random-question?clientId=${config?.id}`,
            headers: { 'Content-Type': 'application/json;charset=utf-8' }
        })
            .then((res) => {
                if (res.id) {
                    // Enable possible answer
                    if (res.type === 'MCQ' || res.type === 'MULTI_MCQ') {
                        const answersArray = res.possibleAnswers
                            .split('|')
                            .map((answer) => answer.trim());
                        res.possibleAnswers = answersArray;
                        setCheckedState(
                            new Array(answersArray.length).fill(false)
                        );
                    }
                    setQuestion(res);
                    if (res.id !== 178 && res.id !== 179 && res.id !== 180 && res.id!=200) {
                        setisRandomQuestion(true);
                    }  
                    // setisRandomQuestion(true); //To enable the modal
                } else {
                    OnCancelClick();
                }
            })
            .catch(() => {});
    }, []);
   console.log(" Random question from survey form" , question);
    return (
        <div>
            <SideModal
                visible={showModal && isRandomQuestion}
                survey={true}
                className={'w-full  lg:pl-[15%] lg:pr-[15%]'}
                onClick={OnCancelClick}
            >
                <div className="relative p-2 lg:p-4 flex flex-col ">
                    <div className="flex flex-row gap-2">
                        <img
                            className="w-[50px] h-[50px]"
                            src="https://cdn.loyalie.in/1722926441360_question_gif"
                        />
                        <h3 className="font-medium text-base md:text-lg  pr-10  p-2 ">
                            {question?.question}
                        </h3>
                    </div>
                    <GrClose
                        onClick={OnCancelClick}
                        className={`self-center h-4 w-4 cursor-pointer absolute right-5 top-5`}
                    />
                    {/* Text Area  */}
                    {question.type === 'FREE' && (
                        <div className="flex items-center  h-16 lg:h-18 xl:h-20  rounded-lg border border-[#dddddd] p-2 ml-2 lg:ml-[4.5rem] md:ml-[4.5rem]">
                            <textarea
                                type="text"
                                placeholder="Type here"
                                className=" text-black outline-none  w-full  text-grey-900    outline-none placeholder:mt-4"
                                onChange={commentsChangedHandler}
                                value={comments}
                            />
                        </div>
                    )}
                    {/* MCQ & MULT_MCQ Section */}
                    {(question.type === 'MCQ' ||
                        question.type === 'MULTI_MCQ') && (
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 mt-2 lg:pl-[4.5rem] md:pl-[4.5rem] pl-2">
                            {question.possibleAnswers.map((answer, index) => (
                                <div
                                    key={index}
                                    className={`cursor-pointer p-2 rounded-md border-2 font-normal text-base  ${
                                        checkedState[index]
                                            ? 'border-primary text-white bg-primary'
                                            : 'border-gray-100'
                                    }`}
                                    onClick={() => handleBlockClick(index)}
                                >
                                    <p>{answer}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="w-full flex flex-row gap-2 mt-4 justify-start md:justify-end lg:justify-end">
                        <button
                            className="sub-btn px-6 md:px-6 text-white disabled:opacity-70 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            onClick={handleSubmit}
                            disabled={!formIsValid}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </SideModal>
        </div>
    );
}
export default SurveyFrom;
